const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModuleManager from "../../../../framework/core/module_manager";

@ccclass
export default class NetPromptView extends ViewBase {

    @property(cc.Label)
    label_title: cc.Label = null

    @property(cc.Label)
    label_content: cc.Label = null

    @property(cc.Button)
    button_center: cc.Button = null

    @property(cc.Button)
    button_left: cc.Button = null

    @property(cc.Button)
    button_right: cc.Button = null

    show() {
        // ModuleManager.instance.playAnim(true, this.node)
    }

    hide() {
        // ModuleManager.instance.playAnim(false, this.node)
    }
}